import { array } from 'prop-types'
import MultiSelect from '../MultiSelect'

import './styles.scss'

const PersonMultiSelect = (props) => (
  <MultiSelect
    {...props}
    tokenOptions={{ ...(props.tokenOptions || []), avatared: true }}
  />
)

PersonMultiSelect.propTypes = {
  tokenOptions: array,
}

export default PersonMultiSelect
